import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  Loader,
  Stack,
  Title,
} from "@advarra-engineering/advarra-design-system-react";

export function Loading() {
  const { t } = useTranslation();

  return (
    <Stack justify="center" align="center">
      <Loader size={100} />
      <Title order={1}>{t("loading.loading")}</Title>
    </Stack>
  );
}
